import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from '@narvar/moment-shim';
import AdditionalDetails from '../AdditionalDetails';
import { obfuscateNumber } from '../../lib/phone';
import { timeWindowFormatter } from '../../lib/dates';

export const mapStateToProps = ({
  pickup: { service, form: { date, address, phoneNumber, pickupTime } = {} } = {},
  language: {
    [`returns.step_3.pickup_details.${service}.title`]: title,
    [`returns.step_3.pickup_details.${service}.date_label`]: dateLabel,
    [`returns.step_3.pickup_details.${service}.date_addendum`]: dateAddendum,
    [`returns.step_3.pickup_details.${service}.address_label`]: addressLabel,
    [`returns.step_3.pickup_details.${service}.phone_number_label`]: phoneNumberLabel,
  },
}) => ({
  address,
  date,
  title,
  dateLabel,
  dateAddendum,
  addressLabel,
  phoneNumber,
  phoneNumberLabel,
  pickupTime,
});

const PickupDetails = ({
  address: { street_1: street1, street_2: street2, city, state, zip },
  date,
  title,
  dateLabel,
  dateAddendum,
  addressLabel,
  phoneNumber,
  phoneNumberLabel,
  pickupTime,
}) => {
  const dateDisplay = moment(date).format('dddd, MMMM D');

  return (
    <AdditionalDetails
      wrapperStyle="padding: 0"
      headerStyle="font-weight: 700"
      title={title}
      items={[
        {
          key: dateLabel,
          value: `${dateDisplay} ${pickupTime ? timeWindowFormatter(pickupTime) : dateAddendum}`,
        },
        {
          key: addressLabel,
          value: street2
            ? `${street1}, ${street2}, ${city}, ${state} ${zip}`
            : `${street1}, ${city}, ${state} ${zip}`,
        },
        ...(phoneNumber
          ? [
              {
                key: phoneNumberLabel,
                value: obfuscateNumber(phoneNumber),
              },
            ]
          : []),
      ]}
    />
  );
};

PickupDetails.defaultProps = {
  title: '',
  dateLabel: '',
  dateAddendum: '',
  addressLabel: '',
  phoneNumber: '',
  phoneNumberLabel: '',
  pickupTime: '',
};

PickupDetails.propTypes = {
  address: PropTypes.shape({
    street_1: PropTypes.string,
    street_2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }).isRequired,
  date: PropTypes.string.isRequired,
  title: PropTypes.string,
  dateLabel: PropTypes.string,
  dateAddendum: PropTypes.string,
  addressLabel: PropTypes.string,
  phoneNumber: PropTypes.string,
  phoneNumberLabel: PropTypes.string,
  pickupTime: PropTypes.string,
};

export default connect(mapStateToProps)(PickupDetails);
